import { render, staticRenderFns } from "./declared-oasis-explan.vue?vue&type=template&id=314ab2b7&scoped=true"
import script from "./declared-oasis-explan.vue?vue&type=script&lang=js"
export * from "./declared-oasis-explan.vue?vue&type=script&lang=js"
import style0 from "./declared-oasis-explan.vue?vue&type=style&index=0&id=314ab2b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314ab2b7",
  null
  
)

export default component.exports